import { Tooltip, withStyles } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

const InfoBaseIcon = withStyles(() => ({
  root: {
    fontSize: 16,
    color: "#566474",
    cursor: "pointer",
  },
}))(InfoOutlinedIcon);

export default function InfoIcon({ TooltipComponent, iconProps, ...props }) {
  return <Tooltip {...props}>{TooltipComponent ? TooltipComponent : <InfoBaseIcon {...iconProps} />}</Tooltip>;
}
